import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import MenuBar from "../components/MenuBar";
import Login from "../components/Login";
import ChangePassword2 from "./Password/ChangePassword2";
import GlobalSessionHandler from "../components/GlobalSessionHandler";
import PopupModal from "../components/PopupModal"; 

function App() {
  const history = useHistory();
  const userDetails = JSON.parse(sessionStorage.getItem("getUser"));

  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (userDetails && window.location.pathname === "/login") {
      history.push("/"); 
    }
  }, [userDetails, history]);

  useEffect(() => {
    const handleCustomPopup = (e) => {
      setPopupMessage(e.detail.message);
      setShowPopup(true);
    };

    window.addEventListener("customPopup", handleCustomPopup);
    return () => {
      window.removeEventListener("customPopup", handleCustomPopup);
    };
  }, []);

  return (
    <div className="container-fluid mb-5">
      {/* Popup modal */}
      {showPopup && (
        <PopupModal message={popupMessage} onClose={() => setShowPopup(false)} />
      )}

      <GlobalSessionHandler />
      {userDetails &&
        (userDetails.isChangePassword === null ||
        userDetails.isChangePassword === 0 ? (
          <ChangePassword2 />
        ) : (
          <MenuBar />
        ))}
      {!userDetails && <Login />}
    </div>
  );
}

export default App;